/**
 * Instance Admin as a modal — opened from the user menu in the TopBar. Wraps
 * the same {@link InstanceAdminConsole} the `/admin` route renders, so the two
 * surfaces never drift. Resizable + maximizable with a persisted size, since
 * the console holds a lot (settings tabs, analytics, waitlist).
 *
 * The instance-admin gate lives on the caller (the menu item only shows for
 * `user.is_instance_admin`) and, authoritatively, on every backend endpoint
 * the console calls — so this component doesn't re-check.
 */
import Modal from '@/components/common/Modal'
import { InstanceAdminConsole } from './InstanceAdminPage'

export default function InstanceAdminModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal
      open
      onClose={onClose}
      title="Instance Admin"
      size="full"
      resizable
      maximizable
      storageKey="instance-admin-modal"
    >
      {/* Modal makes the body a flex column with internal scrolling when
          resizable/maximizable — own the scroll region here. */}
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingRight: 4 }}>
        <InstanceAdminConsole />
      </div>
    </Modal>
  )
}
